import * as React from "react";
import { IconButton } from "@material-ui/core";
import PrintIcon from "@mui/icons-material/Print";
import PropTypes from "prop-types";
import dayjs from "dayjs";
// import $ from "jquery";
const headers = [
  "#",
  "Mã HĐ",
  "Khách hàng",
  "SĐT",
  "Địa chỉ",
  "Tiền phải đóng",
  "Lý do"
];
const headers2 = ["#", "Mã HĐ", "Khách hàng", "SĐT", "Tài sản", "VNĐ", "Lý do"];
const headersMap = [
  "id",
  "customerName",
  "phone",
  "address",
  "amountDelay",
  "textNotice"
];
const headersMap2 = [
  "id",
  "customerName",
  "phone",
  "collateralType",
  "loanAmount",
  "textNotice"
];
const columnWidths = {
  id: "40px",
  contractId: "50px",
  customerName: "200px",
  phone: "100px",
  address: "250px",
  amountDelay: "50px",
  textNotice: "300px"
};
const moneyFields = ["amountDelay", "loanAmount"];
const CustomTableToolbar = ({ data, title, id }) => {
  const printDiv = () => {
    const newWindow = window.open();
    const newTitle = title?.props?.children.replace(
      "Cảnh Báo",
      "Danh sách hợp đồng"
    );
    const isTraGop = id.includes("tra-gop");
    const contractPrefix = isTraGop ? "BH-" : "TC-";
    const headersTmp = isTraGop ? headers : headers2;
    const headersMapTmp = isTraGop ? headersMap : headersMap2;
    let printContent = ``;
    printContent +=
      '<table style="width:100% ;border-collapse: collapse;"><tr>';
    let contentTable = "";
    headersTmp.forEach((header, idx) => {
      const fieldKey = headersMapTmp[idx];
      const extraStyle = columnWidths[fieldKey]
        ? `width:${columnWidths[fieldKey] || "auto"};`
        : "";
      printContent += `<th style="border:1px solid black;border-collapse: collapse;font-size: 12px; text-align: center; padding: 3px; word-wrap: break-word;white-space: normal; ${extraStyle}">${header}</th>`;
    });

    data.forEach((item, index) => {
      contentTable += "<tr>";
      contentTable += `<td style="border:1px solid black;border-collapse: collapse;font-size: 12px;padding: 3px;">${index +
        1}</td>`;
      headersMapTmp.forEach(header => {
        const prefix = header === "id" ? contractPrefix : "";
        let value =
          header === "loanDate"
            ? dayjs(item[header]).format("DD/MM/YYYY")
            : item[header];
        if (moneyFields.includes(header)) {
          value = `${value?.toLocaleString("en-US") || 0}`;
        }
        const extraStyle = columnWidths[header]
          ? `width:${columnWidths[header] || "auto"};`
          : "";
        contentTable += `<td style="border:1px solid black;border-collapse: collapse;font-size: 12px;padding: 3px; word-wrap:break-word;white-space:normal; ${extraStyle}">${prefix}${value ??
          ""}</td>`;
      });
      contentTable += "</tr>";
    });

    printContent += `</tr>${contentTable}`;
    printContent += "</table>";

    newWindow.document.write(printContent);
    newWindow.document.title = newTitle;
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.onafterprint = () => newWindow.close();
  };

  const handleClick = () => {
    printDiv();
  };
  return (
    <IconButton
      onClick={handleClick}
      sx={{
        display: "none"
      }}
    >
      <PrintIcon />
    </IconButton>
  );
};

CustomTableToolbar.propTypes = {
  data: PropTypes.any,
  title: PropTypes.any,
  id: PropTypes.any
};

export default CustomTableToolbar;
